import { Footer } from 'widgets/Footer'
import logo from 'shared/assets/images/logo.svg'
import { GoogleAuth } from './GoogleAuth'
import { KeycloackAuth } from './KeycloackAuth'

type Props = {
  setToken: (t: string) => void
}

export function AuthPage({ setToken }: Props) {
  return (
    <section className='relative flex h-full w-full flex-col bg-zinc-50'>
      <div className='flex grow flex-col items-center justify-center gap-y-10'>
        <img
          src={logo}
          width={146}
          height={27}
          alt='Digital Future'
        />
        {import.meta.env.PROD ? (
          <KeycloackAuth />
        ) : (
          <GoogleAuth onAuth={setToken} />
        )}
      </div>
      <Footer />
    </section>
  )
}
